// extracted by mini-css-extract-plugin
export default {"special-text":"DateTemplate_special-text__fl24J"};